import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, ShieldCheck, Lock } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
export function OfferSection() {
  const faqs = [{
    q: '¿Es esto contra mi religión?',
    a: 'Al contrario. Este proceso se basa en el principio bíblico de la libertad en Cristo y el perdón generacional. Juan 8:32 dice: "Y conoceréis la verdad, y la verdad os hará libres." Eso es exactamente lo que este manual te ayuda a experimentar.'
  }, {
    q: '¿Tengo que hablar con mi familia para que esto funcione?',
    a: 'No. Este es un trabajo completamente interno y espiritual. No necesitas el permiso ni la participación de nadie más. Tu sanación es tuya y solo tuya. De hecho, al liberarte tú, el sistema familiar completo comienza a sanar sin que nadie más tenga que hacer nada.'
  }, {
    q: '¿Cuánto tiempo toma al día?',
    a: 'Entre 15 y 20 minutos diarios durante 7 días. Puedes hacerlo antes de dormir, en tu tiempo de oración o en cualquier momento de quietud. Está diseñado para la vida real de una mujer ocupada.'
  }, {
    q: '¿Es seguro hacer este proceso sola?',
    a: 'Completamente. El proceso fue diseñado para ser un acompañamiento compasivo y suave. No es confrontacional ni traumático. Es un acto de amor hacia ti misma y hacia tu historia. Si en algún momento sientes emociones muy intensas, date permiso de pausar y respirar. Eso también es parte de la sanación.'
  }, {
    q: '¿Qué pasa si compro y no funciona para mí?',
    a: 'Tienes 30 días de garantía total. Si aplicas el proceso completo y no sientes ningún cambio real, te devolvemos cada centavo sin preguntas y sin complicaciones. El riesgo es completamente nuestro.'
  }];
  const [openFaq, setOpenFaq] = useState<number | null>(0);
  return <section id="offer-section" className="pt-10 pb-20 px-4 bg-cream" data-id="element-130">
      <div className="max-w-4xl mx-auto" data-id="element-131">
        {/* FAQ */}
        <div className="mb-24" data-id="element-132">
          <h2 className="text-3xl font-serif text-charcoal font-bold mb-10 text-center" data-id="element-133">
            Preguntas Frecuentes
          </h2>
          <div className="space-y-4 max-w-2xl mx-auto" data-id="element-134">
            {faqs.map((faq, i) => <div key={i} className="bg-white border border-gold/20 shadow-sm" data-id="element-135">
                <button onClick={() => setOpenFaq(openFaq === i ? null : i)} className="w-full px-6 py-4 flex items-center justify-between text-left focus:outline-none" data-id="element-136">
                  <span className={`font-serif font-bold text-lg ${openFaq === i ? 'text-gold-dark' : 'text-charcoal'}`} data-id="element-137">
                    {faq.q}
                  </span>
                  <ChevronDown className={`text-gold transition-transform duration-300 ${openFaq === i ? 'rotate-180' : ''}`} data-id="element-138" />
                </button>
                <AnimatePresence data-id="element-139">
                  {openFaq === i && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} className="overflow-hidden" data-id="element-140">
                      <div className="px-6 pb-4 text-charcoal-light" data-id="element-141">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>
        </div>

        {/* Guarantee */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white border-2 border-gold p-8 md:p-12 text-center mb-10 relative shadow-lg" data-id="element-142">
          <div className="absolute -top-8 left-1/2 -translate-x-1/2 bg-cream rounded-full p-2" data-id="element-143">
            <div className="bg-gold text-white rounded-full p-4 shadow-md" data-id="element-144">
              <ShieldCheck size={40} data-id="element-145" />
            </div>
          </div>

          <h3 className="text-2xl font-serif font-bold text-charcoal mt-6 mb-4" data-id="element-146">
            NUESTRA PROMESA Y GARANTÍA DE FE TOTAL (30 DÍAS)
          </h3>
          <p className="text-charcoal-light leading-relaxed" data-id="element-147">
            Estamos tan seguros de la potencia de este proceso que el riesgo es
            todo nuestro. Si descargas el manual, aplicas los pasos durante 7
            días y no sientes una liberación real en tu espíritu o una claridad
            absoluta sobre tu camino,{' '}
            <strong className="text-charcoal" data-id="element-148">
              te devolvemos el 100% de tu inversión.
            </strong>{' '}
            Sin preguntas, sin complicaciones. Tu sanación es nuestra única
            prioridad.
          </p>
        </motion.div>

        {/* Offer & Price */}
        <div className="text-center bg-white p-8 md:p-12 shadow-xl border border-gold/30 relative overflow-hidden" data-id="element-149">
          <div className="absolute top-0 right-0 w-32 h-32 bg-gold/10 rounded-bl-full -z-10" data-id="element-150"></div>
          <div className="absolute bottom-0 left-0 w-32 h-32 bg-gold/10 rounded-tr-full -z-10" data-id="element-151"></div>

          <h3 className="text-2xl md:text-3xl font-serif font-bold text-charcoal mb-8" data-id="element-152">
            Esta Semana Santa, tienes dos caminos.
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10 max-w-2xl mx-auto text-left" data-id="element-153">
            {/* Camino A */}
            <div className="bg-cream-light border border-gray-200 p-6 rounded-sm" data-id="element-154">
              <p className="font-serif font-bold text-charcoal-light text-lg mb-3 flex items-center gap-2" data-id="element-155">
                <span className="text-red-400/80 text-xl" data-id="element-156">✕</span> CAMINO A
              </p>
              <p className="text-sm text-charcoal-light italic mb-2 font-semibold" data-id="element-157">
                Sin este manual:
              </p>
              <p className="text-charcoal-light text-sm leading-relaxed" data-id="element-158">
                Otra semana, otro mes, otro año sintiendo el mismo peso. Tus
                hijos heredando lo que tú heredaste.
              </p>
            </div>

            {/* Camino B */}
            <div className="bg-charcoal border border-gold/30 p-6 rounded-sm" data-id="element-159">
              <p className="font-serif font-bold text-gold text-lg mb-3 flex items-center gap-2" data-id="element-160">
                <span className="text-gold text-xl" data-id="element-161">✓</span> CAMINO B
              </p>
              <p className="text-sm text-gold/80 italic mb-2 font-semibold" data-id="element-162">
                Con este manual:
              </p>
              <p className="text-cream-dark text-sm leading-relaxed" data-id="element-163">
                En 7 días, sabes exactamente qué cadena te ha tenido atada. Y
                tienes el protocolo para cortarla para siempre.
              </p>
            </div>
          </div>

          <p className="text-lg text-charcoal-light mb-6 max-w-lg mx-auto" data-id="element-164">
            La diferencia entre los dos caminos cuesta hoy{' '}
            <span className="text-gold-dark font-bold text-xl" data-id="element-165">$8.49 USD</span>.
          </p>

          <CTAButton pulse href="https://innershiftstore.com/cart/51882289398042:1" text="SÍ, QUIERO ROMPER MIS CADENAS HOY" className="w-full md:w-auto md:px-12 py-5 text-xl mb-6" data-id="element-166" />

          <div className="flex flex-col items-center justify-center gap-2 text-sm text-charcoal-light mt-2" data-id="element-167">
            <div className="flex items-center gap-2 font-medium text-green-700 bg-green-50 px-4 py-2 rounded-full" data-id="element-168">
              <Lock size={16} data-id="element-169" />
              COMPRA 100% SEGURA Y PROTEGIDA
            </div>
            <p data-id="element-170">
              Acceso inmediato tras el pago. Garantía de satisfacción de 30 días
              o te devolvemos tu dinero al instante.
            </p>
          </div>
        </div>
      </div>
    </section>;
}